import * as jstz from 'jstz';
import * as logger from '../logging/logger';

function timeZoneName() {
  let name = null;
  try {
    name = jstz.determine().name();
  }
  catch (e) {
    logger.error(`unable to determine time zone on client: ${e}`);
  }

  if (name) {
    return name;
  }

  return 'Europe/Copenhagen';
}

export default timeZoneName;